import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isMobile from 'ismobilejs';

import Registry from '../../../registry/index';
import { hideLeftSidebar } from '../../../actions/sidebars';
import { minimizeAllPmWindows }  from '../../../actions/pm';
import { openVideoWindow }  from '../../../actions/streaming';
import { readNotification, openNotificationsWindow } from '../../../actions/notifications';

const Notification = ({
    notification,
    counter,
    readNotification,
    openVideoWindow,
    openNotificationsWindow,
    hideLeftSidebar,
    minimizeAllPmWindows
}) => {
    const lang = Registry.get('locale');
    const siteInterface = Registry.get('siteInterface');

    const isEnglish = lang._code === 'en';

    const { type, data: { id, meta }} = notification;

    const onCloseNotification = (e, instant) => {
        e.stopPropagation();
        if (instant) {
            readNotification({processedList: [notification.data.id]});
        } else {
            siteInterface.applyMemberNotificationAction({ ids: [id] })
                .then((data) => readNotification(data.data.data))
                .catch(err => console.error(err.message));
        }
    };

    const onOpenNotification = e => {
        if (meta && meta.url) {
            const win = window.open(meta.url, '_blank');
            onCloseNotification(e);
            win.focus();
        } else {
            openNotificationsWindow();
        }
    };

    const onOpenVideo = e => {
        openVideoWindow(meta.user.ufrag);
        onCloseNotification(e,true);
    };

    const onOpenNotificationsWindow = () => {
        if (isMobile.any) {
            hideLeftSidebar();
            minimizeAllPmWindows();
        }
        openNotificationsWindow();
    };

    return (
        <Fragment>
            <div className="name notifications" onClick={onOpenNotificationsWindow}>
                {lang.notifications}
                <span className="counter">{counter}</span>
            </div>
            {(type === "tip" || type === "tip_private_received") &&
                <div className="notification-container">
                    <p className="notification" onClick={onOpenNotification}>
                        {`${meta.user.nick} ${lang.tip(meta.amount)}`}
                    </p>
                    <a className="hide" onClick={onCloseNotification}>&times;</a>
                </div>
            }
            {(type === "new_follower" || type === "guestbook_message") &&
                <div className="notification-container">
                    <p className="notification"  onClick={onOpenNotification}>
                        {isEnglish ?
                            `${lang[type]} ${meta.user.nick}`
                            :
                            `${meta.user.nick} ${lang[type]}`
                        }
                    </p>
                    <a className="hide" onClick={onCloseNotification}>&times;</a>
                </div>
            }
            {(type === "gift" || type === "message") &&
                <div className="notification-container">
                    <p className="notification" onClick={onOpenNotification}>
                        {meta.user.nick} {lang[type]}
                    </p>
                    <a className="hide" onClick={onCloseNotification}>&times;</a>
                </div>
            }
            {type === "membership_gift" &&
                <div className="notification-container">
                    <p className="notification" onClick={onOpenNotification}>
                        {meta.user.nick} {lang[type].replace('%1', meta.duration )}
                    </p>
                    <a className="hide" onClick={onCloseNotification}>&times;</a>
                </div>
            }
            {(type === "user_membership_expired" || type === "user_membership_almost_expired") &&
                <div className="notification-container">
                    <p className="notification" onClick={onOpenNotification}>
                        {lang[type].replace('%1', new Date(meta.expiration_date * 1000).toLocaleDateString())}
                    </p>
                    <a className="hide" onClick={onCloseNotification}>&times;</a>
                </div>
            }
            {type === "followed_user_is_online" &&
                <div className="notification-container" onClick={onOpenVideo}>
                    <p className="notification">
                        {meta.user.nick} {lang[type]} {meta.room.name}
                    </p>
                    <a className="hide" onClick={e => onCloseNotification(e, true)}>&times;</a>
                </div>
            }
            {type === "stream_record_error" &&
                <div className="notification-container">
                    <p className="notification" onClick={onOpenNotification}>
                        {lang.streamRecordError}
                    </p>
                    <a className="hide" onClick={onCloseNotification}>&times;</a>
                </div>
            }
        </Fragment>
    );
};

const mapDispatchToProps = {
    openNotificationsWindow,
    minimizeAllPmWindows,
    readNotification,
    openVideoWindow,
    hideLeftSidebar,
};

Notification.propTypes = {
    notification: PropTypes.object.isRequired,
    counter: PropTypes.number.isRequired
};

export default connect(null, mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/Notification/index.js